import { render, staticRenderFns } from "./CategoriesPage.vue?vue&type=template&id=0da64004&"
import script from "./CategoriesPage.vue?vue&type=script&lang=js&"
export * from "./CategoriesPage.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesPage.vue?vue&type=style&index=0&id=0da64004&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports